import React from 'react';
import { matchPath, NavLink, useLocation } from 'react-router-dom';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Label } from '@atlas/ui';

const HeaderSubmenuList = ({ className, isHovered, link, subpages, visible, wrapperClassName }) => {
  const { pathname } = useLocation();

  const itemClassName = cx('tab-link', className, {
    active: matchPath(pathname, { exact: true, path: link, strict: true }),
  });

  const containerClassName = cx('subpages-list', wrapperClassName, {
    'item-submenu': isHovered,
    visible,
  });

  return (
    <div className={containerClassName}>
      {subpages?.map(item => {
        const { id, location, name } = item;

        return (
          <NavLink className={itemClassName} key={id} to={location}>
            <Label message={name} />
          </NavLink>
        );
      })}
    </div>
  );
};

HeaderSubmenuList.propTypes = {
  className: PropTypes.string,
  isHovered: PropTypes.bool,
  link: PropTypes.string,
  subpages: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  visible: PropTypes.bool,
  wrapperClassName: PropTypes.string,
};

export default HeaderSubmenuList;
